<template>
    <div class="route-view-box">
        <router-view :key="$route.name" />
        <!-- 信息修改成功后提示 -->
        <div class="text-center">
            <v-snackbar v-model="snackbars">{{ snackbarInfor }}</v-snackbar>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
    name: "route-view-box",
    data() {
        return {
            snackbars: false
        };
    },
    computed: {
        ...mapState("triggerEvtents", ["snackbar", "snackbarInfor"])
    },
    watch: {
        //  路由返回首页时重新加载数据
        $route(to, from) {
            this.updateInitSearchCondition();
            this.updateGetSchemaData();
            if (
                from.path.includes("favorites") &&
                this.$P.schemaType == "favoritePictures"
            ) {
                this.updateInitSearchCondition();
                this.$P.schemaType = "basicData";
                this.updateGetSchemaData();
            }
        },
        snackbar(newData) {
            this.snackbars = true;
            // $(".v-snack__wrapper").removeClass("theme--darken-1");
        }
    },

    mounted() {},
    beforeDestroy() {},
    methods: {
        ...mapMutations("triggerEvtents", [
            "updateGetSchemaData",
            "updateInitSearchCondition"
        ])
    }
};
</script>

<style lang="scss">
.route-view-box {
}
</style>
